export default {
  properties: {
    default: { type: 'string' },
    prefix: { type: 'string' },
    suffix: { type: 'string' },
  },
};
